module.exports = __webpack_public_path__ + "media/tsemppiaani1.f8cc25c4.wav";